import styled from 'styled-components';

export const RecipeTypeDescription = styled.div`
  font-size: 0.7em;
  color: gray;
`;

export const RecipeIdentification = styled.div`
  font-weight: bold;
`;

export const RecipeFileBlock = styled.div`
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  text-align: center;
  background-color: #fff9f9;
`;

export const DiagnosticBlock = styled.div`
  margin-bottom: 10px;
`;

export const DiagnosticDistanceType = styled.div`
  padding-bottom: 5px;
`;

export const DiagnosticContainerTable = styled.div`
  margin-bottom: 10px;
`;

export const ConfirmationBlock = styled.div`
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  color: gray;
`;

export const RegistrationBlock = styled.div`
  padding-top: 5px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: gray;
  border-top: 1px solid #ddd;
`;

export const DateTimeBlock = styled.div`
  font-size: 0.8em;
  color: #aaa;
`;

export const FlexColumnBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SecundaryRecipeInformation = styled.div`
`;

export const HeaderCard = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const HeaderLeftContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const HeaderRightContent = styled.div`
`;